<main class="main-content" [class.has-bottom-nav]="isAuthenticated">
  <router-outlet></router-outlet>
</main>

<!-- Sub-menu overlay -->
<div class="submenu-overlay" *ngIf="activeSubmenu" (click)="closeSubmenu()"></div>

<!-- Sub-menu above bottom nav -->
<div class="submenu-panel" *ngIf="isAuthenticated" [class.visible]="activeSubmenu">
  <div class="submenu-items">
    <button *ngFor="let item of getActiveSubmenuItems()"
       class="submenu-item"
       [class.disabled]="item.disabled"
       (click)="onSubmenuItemClick(item)">
      <span class="submenu-icon-circle">{{ item.icon }}</span>
      <span class="submenu-label">{{ item.label }}</span>
      <span *ngIf="item.disabledHint" class="submenu-hint">{{ item.disabledHint }}</span>
    </button>
  </div>
</div>

<!-- Global Bottom Navigation Bar (authenticated only) -->
<nav class="bottom-nav safe-area-inset-bottom" *ngIf="isAuthenticated">
  <ng-container *ngFor="let tab of navTabs">
    <button class="nav-item" [class.active]="isTabActive(tab)" [class.disabled]="tab.disabled" (click)="onTabClick(tab)">
      <!-- Logo for Inicio -->
      <img *ngIf="tab.logoSrc" [src]="tab.logoSrc" [alt]="tab.label" class="nav-logo">
      <!-- SVG icons for other tabs -->
      <ng-container *ngIf="!tab.logoSrc">
        <svg *ngIf="tab.id === 'lugares'" class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
        <svg *ngIf="tab.id === 'pedidos'" class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>
        <svg *ngIf="tab.id === 'juegos'" class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="2" y="6" width="20" height="12" rx="2"/>
          <circle cx="8" cy="12" r="2"/>
          <path d="M15 9.5v5M12.5 12h5"/>
        </svg>
        <svg *ngIf="tab.id === 'perfil'" class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </ng-container>
      <span class="nav-label">{{ tab.label }}</span>
    </button>
  </ng-container>
</nav>

<!-- Game components (global, only when authenticated) -->
<ng-container *ngIf="isAuthenticated">
  <app-snake-game #snakeGame></app-snake-game>
  <app-memory-game #memoryGame></app-memory-game>
</ng-container>

<!-- PWA Install Prompts -->
<app-pwa-install-prompt></app-pwa-install-prompt>
